import { Card } from "../../components/ui/card";
import { MessageSquare, ExternalLink } from "lucide-react";
import { PLATFORM_BY_KEY, ClientPickerButton } from "./common";

export function InboxTab({ clients, accountsByClient, selectedClientId, onClientChange }) {
  const clientId = selectedClientId;
  const setClientId = onClientChange;
  const clientAccounts = accountsByClient[clientId] || [];

  const externalLinks = (a) => {
    const uname = (a.username || "").replace(/^@/, "");
    if (a.platform === "instagram") return { url: `https://business.facebook.com/latest/inbox/all?asset_id=${uname}`, label: "Meta Business Suite Inbox" };
    if (a.platform === "facebook") return { url: "https://business.facebook.com/latest/inbox/all", label: "Meta Business Suite Inbox" };
    if (a.platform === "tiktok") return { url: `https://www.tiktok.com/tiktokstudio/inbox`, label: "TikTok Studio Inbox" };
    if (a.platform === "youtube") return { url: "https://studio.youtube.com/", label: "YouTube Studio" };
    return null;
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 flex-wrap">
        <ClientPickerButton clients={clients} value={clientId} onChange={setClientId} testid="inbox-client-picker" filterFn={c => (accountsByClient[c.client_id] || []).length > 0} />
      </div>
      <Card className="p-4 border-blue-200 bg-blue-50">
        <div className="text-sm text-blue-800 font-medium flex items-center gap-1.5"><MessageSquare className="w-4 h-4" /> Inbox unificata: coming soon</div>
        <div className="text-xs text-blue-700 mt-1">Zernio non espone ancora API per messaggi diretti/inbox. Qui trovi i link diretti alle inbox native per ogni account collegato del cliente.</div>
      </Card>
      {!clientId && <Card className="p-6 text-center text-sm text-muted-foreground">Seleziona un cliente per vedere gli account collegati.</Card>}
      {clientId && (
        <div className="grid md:grid-cols-2 gap-5">
          {clientAccounts.map(a => {
            const meta = PLATFORM_BY_KEY[a.platform];
            const link = externalLinks(a);
            return (
              <Card key={a.account_id} className="p-5 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md" data-testid={`inbox-account-${a.platform}`}>
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${meta?.gradient || 'from-slate-400 to-slate-600'} flex items-center justify-center text-white`}>
                    {meta?.icon ? <meta.icon className="w-5 h-5" /> : <span className="text-xs font-bold">TT</span>}
                  </div>
                  <div className="flex-1">
                    <div className="font-medium text-sm capitalize">{a.platform}</div>
                    <div className="text-xs text-slate-500">@{a.username}</div>
                  </div>
                  {link && (
                    <a href={link.url} target="_blank" rel="noreferrer" className="text-xs bg-slate-900 text-white px-3 py-1.5 rounded-md hover:bg-slate-800 inline-flex items-center gap-1" data-testid={`inbox-open-${a.platform}`}>
                      <ExternalLink className="w-3 h-3" /> Apri inbox
                    </a>
                  )}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
